import { libraryIdsBeingDeletedSelector } from '~/store/tasks/selectors';
import { useAirSelector } from '~/utils/ReduxUtils';

export const useLibrariesBeingDeleted = () => {
  const libraryIdsBeingDeleted = useAirSelector(libraryIdsBeingDeletedSelector);

  return libraryIdsBeingDeleted;
};
